import React from "react";
import "leaflet/dist/leaflet.css";
import ClipLoader from "react-spinners/ClipLoader";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";

const StoreByState = ({ StoresDetails, storeLoader }) => {
  return (
    <div className="Card_Body">
      <div className="Map text-center">
        {storeLoader ? (
          <div className="Clip_Loader" style={{ minHeight: "320px" }}>
            <ClipLoader color={"rgb(0, 143, 251)"} loading={true} size={50} />
          </div>
        ) : Object.keys(StoresDetails).length > 0 ? (
          <MapContainer
            className="markercluster-map"
            center={[32.741646, -89.678696]}
            zoom={3}
            maxZoom={18}
          >
            <TileLayer
              url="https://api.maptiler.com/maps/topographique/256/{z}/{x}/{y}.png?key=Jwldj418wFeWAGThBHQF"
              attribution=' <a href="http://osm.org/copyright"></a>'
            />
            {StoresDetails.map((city, idx) => (
              <CircleMarker
                key={idx}
                center={[city.Latitude, city.Longitude]}
                radius={Math.max(6, Math.sqrt(city.Stores) * 3)}
                pathOptions={{
                  color: "#3d8ecc",
                  fillColor: "#3d8ecc",
                  fillOpacity: 0.65,
                  weight: 1.5
                }}
              >
                <Popup>
                  <b>Stores: {city.Stores}, State: {city.State}</b>
                </Popup>
              </CircleMarker>
            ))}
          </MapContainer>
        ) : (
          "No Stores Available"
        )}
      </div>
    </div>
  );
};

export default StoreByState;
